import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService, UserService} from "../services";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import {first} from "rxjs/operators";
import {CustomerSourceService} from "../services/customerSource.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";

@Component({
    templateUrl: './customerSource.component.html',
    styleUrls: ['./customerSource.component.scss']
})
export class CustomerSourceComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private userService: UserService,
        private customerSourceService: CustomerSourceService,
        private alertService: AlertService,
        private _fuseSidebarService: FuseSidebarService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Customer sources');
    }

    ngOnInit() {
        this.customerSourceService.getAll().pipe(first())
            .subscribe( res => {
                    this.rows = res;
                    this.loadingIndicator = false;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }
}
